import { action } from 'typesafe-actions';
import {
  AuthorisationActionTypes,
  Params,
  Options,
  AuthorisationUpdateActionPayload,
  AuthorisationAddPayload,
  AddAuthorisationOrderStartNew
} from 'types';
export const getAuthorisationStart = (id: number) =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_START, id);
export const getAuthorisationSuccess = (payload: any) =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_SUCCESS, payload);
export const getAuthorisationFailure = (payload: string) =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_FAILURE, payload);
export const listAuthorisationsStart = (params: Params) =>
  action(AuthorisationActionTypes.LIST_AUTHORISATIONS_START, params);
export const listAuthorisationsSuccess = (payload: any) =>
  action(AuthorisationActionTypes.LIST_AUTHORISATIONS_SUCCESS, payload);
export const listAuthorisationsFailure = (payload: string) =>
  action(AuthorisationActionTypes.LIST_AUTHORISATIONS_FAILURE, payload);
export const deleteAuthorisationStart = (id: number) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_START, id);
export const deleteAuthorisationSuccess = (id: number) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_SUCCESS, id);
export const deleteAuthorisationFailure = (payload: string) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_FAILURE, payload);
export const updateAuthorisationStart = (
  payload: AuthorisationUpdateActionPayload
) => action(AuthorisationActionTypes.UPDATE_AUTHORISATION_START, payload);
export const updateAuthorisationSuccess = (payload: any) =>
  action(AuthorisationActionTypes.UPDATE_AUTHORISATION_SUCCESS, payload);
export const updateAuthorisationFailure = (payload: string) =>
  action(AuthorisationActionTypes.UPDATE_AUTHORISATION_FAILURE, payload);
export const addAuthorisationStart = (payload: AuthorisationAddPayload) =>
  action(AuthorisationActionTypes.ADD_AUTHORISATION_START, payload);
export const addAuthorisationSuccess = (payload: any) =>
  action(AuthorisationActionTypes.ADD_AUTHORISATION_SUCCESS, payload);
export const addAuthorisationFailure = (payload: string) =>
  action(AuthorisationActionTypes.ADD_AUTHORISATION_FAILURE, payload);
export const addAuthorisationOrderStart = (
  payload: AddAuthorisationOrderStartNew
) => action(AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_START, payload);
export const addAuthorisationOrderSuccess = (payload: any) =>
  action(AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_SUCCESS, payload);
export const addAuthorisationOrderFailure = (payload: string) =>
  action(AuthorisationActionTypes.ADD_AUTHORISATION_ORDER_FAILURE, payload);
export const deleteAuthorisationOrderStart = (
  authorisationId: number,
  orderId: number
) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_START, {
    authorisationId,
    orderId
  });
export const deleteAuthorisationOrderSuccess = (payload: any) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_SUCCESS, payload);
export const deleteAuthorisationOrderFailure = (payload: string) =>
  action(AuthorisationActionTypes.DELETE_AUTHORISATION_ORDER_FAILURE, payload);

export const clearAllAuthorisations = () =>
  action(AuthorisationActionTypes.CLEAR_ALL_AUTHORISATIONS);
export const clearSelectedAuthorisation = () =>
  action(AuthorisationActionTypes.CLEAR_SELECTED_AUTHORISATION);

export const getAuthorisationTypesStart = () =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_TYPES_START);
export const getAuthorisationTypesSuccess = (payload: Options) =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_TYPES_SUCCESS, payload);
export const getAuthorisationTypesFailure = () =>
  action(AuthorisationActionTypes.GET_AUTHORISATION_TYPES_FAILURE);
export const clearError = () => action(AuthorisationActionTypes.CLEAR_ERROR);

export const purchaseAuthorisationStart = (payload: any) =>
  action(AuthorisationActionTypes.PURCHASE_AUTHORISATION_START, payload);
export const purchaseAuthorisationSuccess = (payload: any) =>
  action(AuthorisationActionTypes.PURCHASE_AUTHORISATION_SUCCESS, payload);
export const purchaseAuthorisationFailure = (payload: string) =>
  action(AuthorisationActionTypes.PURCHASE_AUTHORISATION_FAILURE, payload);
export const purchaseAuthorisationOrderStart = (payload: any) =>
  action(AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_START, payload);
export const purchaseAuthorisationOrderSuccess = (payload: any) =>
  action(
    AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_SUCCESS,
    payload
  );
export const purchaseAuthorisationOrderFailure = (payload: string) =>
  action(
    AuthorisationActionTypes.PURCHASE_AUTHORISATION_ORDER_FAILURE,
    payload
  );
export const clearPurchaseAuthorisation = () =>
  action(AuthorisationActionTypes.CLEAR_PURCHASE_AUTHORISATION);
